import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfunds',
})
@Injectable()
export class SearchFundsPipe implements PipeTransform {
  private NOT_FOUND = -1;
  transform(items: any[], field: string, value: string): any[] {
    let results;
    if (!items) {
      return [];
    }
    if (value === undefined || !value.length) {
      return;
    }

    value = value.toLowerCase();
    results = items.filter((it) => {
      const issue = it[field].toLowerCase();
      const issueName = it.issueName.toLowerCase();
      return (
        issue.indexOf(value) !== this.NOT_FOUND ||
        issueName.indexOf(value) !== this.NOT_FOUND
      );
    });

    return results.length > 0 ? results : [-1];
  }
}
